module.exports = __webpack_public_path__ + "img/the-missing-link-blue.6d923e80.svg";